<template>
  <div id="example-fish-otd">
    <v-container fluid grid-list-md>
    <v-layout row wrap v-for="post of posts.data" :key="post.SpeciesRefNo">
        <v-card v-if="posts">
        <v-img
          src="http://www.azgardens.com/wp-content/uploads/2017/06/Leopard-Gourami-Fish.jpg"
          href="http://www.azgardens.com/wp-content/uploads/2017/06/Leopard-Gourami-Fish.jpg"
          aspect-ratio="1.5"
        ></v-img>

        <v-card-title primary-title >
          <div v-if="post.FBname">
            <h3 class="headline mb-0">{{post.FBname}}</h3>
            <div>
              <i>{{post.Genus + ' ' + post.Species}}</i>
            </div>
          </div>
        </v-card-title>

        <v-card-text>
          <h3>DATA</h3>
          <hr>
            <ul>
              <li>
                <p><b>Genus: </b>{{post.Genus}}</p>
              </li>
              <li>
                <p><b>Species: </b>{{post.Species}}</p>
              </li>
              <li>
                <p><strong>Aquarium: </strong>{{post.Aquarium}}</p>
              </li>
              <li>
                <p><strong>AquariumFishII: </strong>{{post.AquariumFishII}}</p>
              </li>
              <li>
                <p><strong>AquariumRef: </strong>{{post.AquariumRef}}</p>
              </li>
              <li>
                <p><strong>Author: </strong>{{post.Author}}</p>
              </li>
              <li>
                <p><strong>Dangerous: </strong>{{post.Dangerous}}</p>
              </li>
              <li>
                <p><strong>Date Checked: </strong>{{post.DateChecked}}</p>
              </li>
              <li>
                <p><b>Date Entered: </b>{{post.DateEntered}}</p>
              </li>
              <li>
                <p><b>Date Modified: </b>{{post.DateModified}}</p>
              </li>
              <li>
                <p><b>DemersPelag: </b>{{post.DemersPelag}}</p>
              </li>
              <li>
                <p><b>Electrogenic: </b>{{post.Electrogenic}}</p>
              </li>
              <li>
                <p><b>Fishbase Entries: </b>{{post.Entered}}</p>
              </li>
              <li>
                <p><b>Family DB Code: </b>{{post.FamCode}}</p>
              </li>
              <li>
                <p><b>Genus DB Code: </b>{{post.GenCode}}</p>
              </li>
              <li>
                <p><b>Length: </b>{{post.Length}} cm</p>
              </li>
            </ul>

            <ul v-if="errors && errors.length">
              <li v-for="error of errors" :key="error">
                {{error.message}}
              </li>
            </ul>
        </v-card-text>

      </v-card>
    </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      posts: [],
      images: [],
      errors: [],
      FishBaseURL: 'https://fishbase.ropensci.org/',
      searchURL: '',
      imageURL: 'https://services.natureserve.org/idd/rest/ns/v1/globalSpecies/images/image',
      apiURL: 'https://www.example.org/w/api.php'
    }
  },
  props: [
    'Species',
    'Genus',
    'Comnames',
    'Ecology',

  ],
  methods: {
    searchFishBase: function (searchTerm) {
      axios.get(this.FishBaseURL + searchTerm)
      .then (response => {
        this.posts = response.data
        console.log(this.posts)
      })
      .catch (e => {
        this.errors.push(e)
      })
    },
    getSearchString: function (type, paramStr) {
      var searchStr = ''
      if (type === 'species') {
        searchStr = searchStr + type + paramStr
      }
      else {
        console.log('Error on fish card! Invalid search type')
        searchStr = ''
      }
      return searchStr
    },
    getSpeciesImage: function (species) {
      var params = "?scientificName=*"
      var imgSrc = ''
      axios.get(this.imageURL + params + species)
        .then (response => {
          imgSrc = response.data
          console.log(imgSrc)
        })
        .catch (e => {
          this.errors.push(e)
          console.log(this.errors)
        })
    }
  },
  computed: {
    species: function () {
      return (this.Species) ? this.Species : 'acutirostre'
    },
  },
  created () {
    this.searchURL = this.getSearchString('species', '?species=' + this.species + '&limit=1')
    // this.searchFishBase('/species?species=acutirostre&limit=1')
    this.searchFishBase(this.searchURL)
  },
  watch: {
    Species(){
      console.log("changed")
      this.searchURL = this.getSearchString('species', '?species=' + this.species + '&limit=10')
      console.log(this.searchURL)
      this.searchFishBase(this.searchURL)
      // this.getSpeciesImage(this.species)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/layouts/sandbox/examples/fishCard.vue